@if (this.userMenu(); as userMenu) {
  <cam-main-menu class="menu" [menuMain]="this.menu" [menuUser]="userMenu"></cam-main-menu>
}

<ng-template #accountTemplate>
  <div class="my-space-account">
    <cam-my-account></cam-my-account>
  </div>
</ng-template>

<ng-template #notifBulletTemplate>
  <cam-notification-bullet
    [filters]="{
      isNew: true,
    }"
  ></cam-notification-bullet>
</ng-template>
